'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import * as DraftsData from 'AdsUI/data/DraftsData';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { getAdAccountsByUserAndTeams } from 'AdsUI/selectors/GlobalFilters';
import { hasUsersAndTeams } from 'AdsUI/selectors/AuthSelectors';
export const fetchDrafts = (returnPromise = false) => (dispatch, getState) => {
  const adAccounts = hasUsersAndTeams(getState()) ? getAdAccountsByUserAndTeams(getState()) : getAdAccounts(getState());
  return wrapReduxAction(DraftsData.fetchAvailableDrafts.bind(null, adAccounts), 'DRAFTS_FETCH', {
    dispatch,
    returnPromise
  });
};
export const createLeadAdDraft = (network, adAccountId, name, leadAdData) => dispatch => {
  const draft = JSON.stringify(leadAdData);
  return wrapReduxAction(DraftsData.createLeadAdDraft.bind(null, network, adAccountId, name, draft), 'LEAD_AD_DRAFT_CREATE', {
    dispatch,
    returnPromise: true
  });
};
export const updateLeadAdDraft = (draftId, network, adAccountId, name, leadAdData) => dispatch => {
  const draft = JSON.stringify(leadAdData);
  return wrapReduxAction(DraftsData.updateLeadAdDraft.bind(null, draftId, network, adAccountId, name, draft), 'LEAD_AD_DRAFT_UPDATE', {
    dispatch,
    returnPromise: true
  });
};
export const createSequenceDraft = (network, adAccountId, name, draftData) => dispatch => {
  const draft = JSON.stringify(draftData);
  return wrapReduxAction(DraftsData.createSequenceDraft.bind(null, network, adAccountId, name, draft), 'SEQUENCE_DRAFT_CREATE', {
    dispatch,
    returnPromise: true
  });
};
export const updateSequenceDraft = (draftId, network, adAccountId, name, draftData) => dispatch => {
  const draft = JSON.stringify(draftData);
  return wrapReduxAction(DraftsData.updateSequenceDraft.bind(null, draftId, network, adAccountId, name, draft), 'SEQUENCE_DRAFT_UPDATE', {
    dispatch,
    returnPromise: true
  });
};
export const deleteDraft = draft => dispatch => wrapReduxAction(DraftsData.deleteDraft.bind(null, draft.id, draft.adNetwork, draft.type), 'DRAFT_DELETE', {
  dispatch,
  allParams: {
    draft
  }
});